import { useState, useEffect, useCallback } from 'react'
import { authHeaders } from '../utils/authFetch'

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080'

export function useCustomerFeedbackData() {
    const [reviews, setReviews] = useState([])
    const [serviceRating, setServiceRating] = useState([])
    const [itemReview, setItemReview] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [lastUpdated, setLastUpdated] = useState(null)

    const fetchAll = useCallback(async () => {
        try {
            setError(null)
            const res = await fetch(`${API_BASE_URL}/api/customer-feedback/data`, { headers: authHeaders() })
            if (!res.ok) throw new Error('Failed to load feedback data')
            const data = await res.json()

            setReviews(data.reviews || [])
            setServiceRating(data.serviceRating || [])
            setItemReview(data.itemReview || [])
            setLastUpdated(new Date())
        } catch (err) {
            console.error('Error fetching feedback data:', err)
            setError(err.message)
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        fetchAll()
    }, [fetchAll])

    return { reviews, serviceRating, itemReview, loading, error, lastUpdated, refetch: fetchAll }
}